import { supabase } from '../config/supabaseClient';

async function invokeFunction(name, body) {
  const { data, error } = await supabase.functions.invoke(name, { body });

  if (error) {
    throw new Error(error.message || `Failed to call ${name}`);
  }
  if (data?.error) {
    throw new Error(data.error);
  }

  return data;
}

export async function getInvoiceDownloadUrl({ orderNumber, phone, orderId }) {
  return invokeFunction('get-invoice', { orderNumber, phone, orderId });
}

export async function trackShipmentLive(orderNumber, phone) {
  return invokeFunction('track-shipment', { orderNumber, phone });
}
